import axios from "axios";
import CUSTOMER_URLS from "./CustomerURLs.js";

const configuration = {
  getValidationConfig() {
    return axios.get(CUSTOMER_URLS.GET_REVIEW_VALIDATION_CONFIG());
  },
};
export default configuration;
